import { LoadableAfterPaint } from '@confluence/loadable';

export const PageTreeSSRExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageTreeSSRExtensionHandler" */ '../src/PageTreeSSRExtensionHandler.tsx'
			)
		).PageTreeSSRExtensionHandler,
});
